import React from 'react';
import { RiUserLine } from 'react-icons/ri';
import Card from '@/components/ui/cards/Card';

export default function ProfileTab({ admin }) {
  return (
    <Card className="rounded-xl border border-gray-200 bg-white px-6 pt-6 pb-6">
      {/* Icon + heading */}
      <div className="flex items-center gap-2 mb-4">
        <RiUserLine className="text-xl text-slate-700" />
        <h3 className="text-lg font-medium">Basic Information</h3>
      </div>

      <table className="w-full text-sm">
        <tbody>
          <tr className="border-b">
            <td className="py-4 w-1/4 text-gray-500">Email</td>
            <td className="py-4 w-1/4 font-medium break-all">
              {admin.email || '—'}
            </td>
            <td className="py-4 w-1/4 text-gray-500">Phone</td>
            <td className="py-4 w-1/4 font-medium break-all">
              {admin.phone_no || '—'}
            </td>
          </tr>
          <tr>
            <td className="py-4 text-gray-500">Status</td>
            <td className="py-4">
              <span
                className={`inline-block px-3 py-1 rounded-full font-semibold ${
                  admin.status === 1 || admin.status === '1'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800'
                }`}
              >
                {(admin.status === 1 || admin.status === '1')
                  ? 'Active'
                  : 'Inactive'}
              </span>
            </td>
            <td className="py-4 text-gray-500">Role</td>
            <td className="py-4 font-medium break-all">
              {admin.role_id?.name || '—'}
            </td>
          </tr>
        </tbody>
      </table>
    </Card>
  );
}
